import { ref } from 'vue'
import { EMPTY_FC } from './gtfsMapLayers.js'

/**
 * Erişim (izokron) harita kaynağı — GTFSMapLibreView bu ref'leri izler ve yeniden çizer.
 * Analiz geri yüklemesi (WP-B restore) bu ref'leri doldurur; `clearIsochronesSignal`
 * senkron temizler, bu yüzden geri yükleme sinyalden SONRA yapılmalıdır.
 */
export const isochroneFeatures = ref([])
/** Coverage görünümü — nüfus servisinin dissolve poligonu */
export const isochroneCoverageFc = ref(EMPTY_FC)
/** Administrative görünümü — mahalle kapsama */
export const isochroneAdminFc = ref(EMPTY_FC)

export function snapshotIsochroneMap() {
  return {
    features: [...(isochroneFeatures.value || [])],
    coverage: isochroneCoverageFc.value || EMPTY_FC,
    administrative: isochroneAdminFc.value || EMPTY_FC,
  }
}

export function restoreIsochroneMap(snapshot) {
  if (!snapshot) return
  isochroneCoverageFc.value = snapshot.coverage || EMPTY_FC
  isochroneAdminFc.value = snapshot.administrative || EMPTY_FC
  isochroneFeatures.value = [...(snapshot.features || [])]
}

export function resetIsochroneMap() {
  isochroneFeatures.value = []
  isochroneCoverageFc.value = EMPTY_FC
  isochroneAdminFc.value = EMPTY_FC
}
